import React from 'react';
import { useTranslation } from 'react-i18next';
import Truncate from 'react-truncate';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  DEFAULT_LANGUAGE,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
} from '../../config/constants';
import {
  CoreLink,
} from '..';


import './style.scss';

const TeaserSmall = ({ entity, showDate }) => {
  const { t } = useTranslation();

  const created = new Date(entity.getIn(['created', 0, 'value']));

  return (
    <div className="TeaserSmall">
      <div className="TeaserSmall__content">
        {showDate &&
          <div className="TeaserSmall__date">
            {created.toLocaleString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })}
          </div>}
        <h5>
          <div>
            <Truncate lines={2} ellipsis="..." trimWhitespace>
              {entity.getIn(['title', 0, 'value'])}
            </Truncate>
          </div>
        </h5>
        <p className="TeaserSmall__more">{t('read_more')}</p>
      </div>
      <div className="TeaserSmall__image">
        <Image
          alt={entity.getIn(['title', 0, 'value'])}
          src={{
            [SCREEN_MOBILE]: entity.getIn(['field_image', 0, 'styles', 'ratio_1_1_xxs']),
            [SCREEN_NORMAL]: entity.getIn(['field_image', 0, 'styles', 'ratio_16_9_sm']),
          }}
          includeWebP
        />
      </div>
      <CoreLink to={entity.getIn(['paths', DEFAULT_LANGUAGE])} className="TeaserSmall__link overlapping-link" />
    </div>
  );
};

export default TeaserSmall;
